import { Component, OnInit } from '@angular/core';
import {FormGroup} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../store/app.states';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {PHQ9Results, Q_PHQ_9} from '../../../../model/questionnaires/questionnaire-phq9';

@Component({
  selector: 'app-questionnaire-phq9',
  templateUrl: './questionnaire-phq9.component.html',
  styleUrls: ['./questionnaire-phq9.component.css']
})
export class QuestionnairePhq9Component implements OnInit {

  qForm: FormGroup;
  dataSource = Q_PHQ_9;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  values: string[] = ['Mai', 'Alcuni giorni', 'Più di metà dei giorni', 'Quasi tutti i giorni'];
  values2q: string[] = ['Per niente difficile', 'Abbastanza difficile', 'Molto difficile', 'Estremamente difficile'];
  results = [];

  /// toolbar
  back = true;
  found = false;
  title = 'PHQ-9';
  destination = '/questionnaires';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  finalScore = 0;

  constructor(private questionnaireService: QuestionnaireService,
              private store: Store<AppState>,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private router: Router) { }

  ngOnInit(): void {

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length - 1; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number) {
    if ($event.isUserInput) {
      if (position > 0 && position <= 9) {
        if (this.results[position - 1] !== null) {
          let dec = 0;
          this.values.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After:', this.finalScore);
            }
            dec++;
          });
        }
        let inc = 0;
        this.values.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc++;
        });
      }
      console.log('Final Score Value set:', this.finalScore);
      this.results[position - 1] = value;
    }
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;
    console.log(this.results);

    if (this.results.length !== this.dataSource.length - 1) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Non hai finito di completare il questionario!';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {
        console.log(this.finalScore);
        const resultToSend = new PHQ9Results(this.doctorID, this.patientSSN, this.results, this.finalScore);
        this.questionnaireService.sendForm(resultToSend, 'phq9', this.uuid);
      }
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

}
